import { render } from "./App.vue?vue&type=template&id=2f794d7e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2f794d7e&lang=scss"

import exportComponent from "/Users/user/crud-projects/crederi-all/crederi_2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__